import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "src/ui/shared/Tooltip";
import { makeStyles } from "tss-react/mui";

import { styled } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
    list: {
        paddingLeft: theme.spacing(5),
    },
    item: {
        marginTop: theme.spacing(1),
    },
}));

const Container = styled("div")({
    fontSize: 16,
    lineHeight: "18.62px",
    flexShrink: 0,
    flex: 0.3,
    display: "flex",
    alignItems: "center",
});

export const BuildVariantLabel = (props: React.PropsWithChildren<{ style?: React.CSSProperties }>) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["common"]);

    return (
        <Container {...props}>
            {props.children}
            <Tooltip
                title={
                    <>
                        {t("common:section.buildVariant.header")}:
                        <ul className={classes.list}>
                            <li className={classes.item}>
                                <strong>{t("common:section.buildVariant.user.title")}:</strong>{" "}
                                {t("common:section.buildVariant.user.description")}
                            </li>
                            <li className={classes.item}>
                                <strong>{t("common:section.buildVariant.userdebug.title")}:</strong>{" "}
                                {t("common:section.buildVariant.userdebug.description")}
                            </li>
                            <li className={classes.item}>
                                <strong>{t("common:section.buildVariant.eng.title")}:</strong>{" "}
                                {t("common:section.buildVariant.eng.description")}
                            </li>
                        </ul>
                    </>
                }
            >
                <i className="fa-solid fa-circle-info" />
            </Tooltip>
        </Container>
    );
};
